import iconThemeColor from "../index";

const PivotFlipTableIcon = ({ fillColor }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5 6.5C5 5.94772 5.44772 5.5 6 5.5H9C9.55228 5.5 10 5.94772 10 6.5V17.5C10 18.0523 9.55228 18.5 9 18.5H6C5.44772 18.5 5 18.0523 5 17.5V6.5Z"
        fill={fillColor}
      />
      <path
        d="M11.5 18.5V14.5H18.5C19.0523 14.5 19.5 14.9477 19.5 15.5V17.5C19.5 18.0523 19.0523 18.5 18.5 18.5H11.5Z"
        fill={fillColor}
      />
      <path
        d="M14.3536 5.64645C14.5488 5.84171 14.5488 6.15829 14.3536 6.35355L13.2064 7.50071C14.2489 7.50803 15.0992 7.57238 15.7864 7.72245C16.5221 7.88314 17.1069 8.14974 17.5411 8.58395C17.9772 9.02013 18.2127 9.57657 18.3419 10.2223C18.4694 10.8601 18.5 11.6213 18.5 12.5C18.5 12.7761 18.2761 13 18 13C17.7239 13 17.5 12.7761 17.5 12.5C17.5 11.6287 17.4681 10.9524 17.3613 10.4184C17.256 9.89218 17.0853 9.54237 16.8339 9.29105C16.5807 9.03776 16.1966 8.83561 15.573 8.69942C14.9853 8.57108 14.2173 8.5082 13.2079 8.50075L14.3536 9.64645C14.5488 9.84171 14.5488 10.1583 14.3536 10.3536C14.1583 10.5488 13.8417 10.5488 13.6464 10.3536L11.6464 8.35355C11.4512 8.15829 11.4512 7.84171 11.6464 7.64645L13.6464 5.64645C13.8417 5.45118 14.1583 5.45118 14.3536 5.64645Z"
        fill={fillColor}
      />
    </svg>
  );
};

const CenterFocusStrongIcon = ({ fillColor }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6 4.5C5.17157 4.5 4.5 5.17157 4.5 6V9H5.5V6C5.5 5.72386 5.72386 5.5 6 5.5H9V4.5H6Z"
        fill={fillColor}
      />
      <path
        d="M15 5.5H18C18.2761 5.5 18.5 5.72386 18.5 6V9H19.5V6C19.5 5.17157 18.8284 4.5 18 4.5H15V5.5Z"
        fill={fillColor}
      />
      <path
        d="M5.5 18V15H4.5V18C4.5 18.8284 5.17157 19.5 6 19.5H9V18.5H6C5.72386 18.5 5.5 18.2761 5.5 18Z"
        fill={fillColor}
      />
      <path
        d="M18.5 15V18C18.5 18.2761 18.2761 18.5 18 18.5H15V19.5H18C18.8284 19.5 19.5 18.8284 19.5 18V15H18.5Z"
        fill={fillColor}
      />
      <path
        d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
        fill={fillColor}
      />
    </svg>
  );
};

const MapIcon = ({ fillColor }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.8143 3.53576C8.92411 3.49184 9.04592 3.48826 9.15811 3.52566L14.9844 5.46774L18.4429 4.08432C19.4282 3.6902 20.5 4.41583 20.5 5.47703V17.323C20.5 17.9363 20.1266 18.4879 19.5571 18.7157L15.1857 20.4642C15.0759 20.5082 14.9541 20.5117 14.8419 20.4743L9.01564 18.5323L5.55709 19.9157C4.57179 20.3098 3.5 19.5842 3.5 18.523V6.67703C3.5 6.06368 3.87343 5.51211 4.44291 5.28432L8.8143 3.53576ZM9.5 17.6396L14.5 19.3063V6.36038L9.5 4.69371V17.6396ZM8.5 4.73852V17.6615L5.1857 18.9872C4.85726 19.1186 4.5 18.8767 4.5 18.523V6.67703C4.5 6.47258 4.62448 6.28873 4.81431 6.21279L8.5 4.73852ZM15.5 6.33852V19.2615L19.1857 17.7872C19.3755 17.7113 19.5 17.5274 19.5 17.323V5.47703C19.5 5.1233 19.1427 4.88142 18.8143 5.01279L15.5 6.33852Z"
        fill={fillColor}
      />
    </svg>
  );
};

const RemoveIcon = ({ fillColor }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 12C7 11.7239 7.22386 11.5 7.5 11.5H16.5C16.7761 11.5 17 11.7239 17 12C17 12.2761 16.7761 12.5 16.5 12.5H7.5C7.22386 12.5 7 12.2761 7 12Z"
        fill={fillColor}
      />
    </svg>
  );
};

const AddIcon = ({ fillColor }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 7C12.2761 7 12.5 7.22386 12.5 7.5V11.5H16.5C16.7761 11.5 17 11.7239 17 12C17 12.2761 16.7761 12.5 16.5 12.5H12.5V16.5C12.5 16.7761 12.2761 17 12 17C11.7239 17 11.5 16.7761 11.5 16.5V12.5H7.5C7.22386 12.5 7 12.2761 7 12C7 11.7239 7.22386 11.5 7.5 11.5H11.5V7.5C11.5 7.22386 11.7239 7 12 7Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const ThemedPivotFlipTableIcon = iconThemeColor(PivotFlipTableIcon);
export const ThemedCenterFocusStrongIcon = iconThemeColor(CenterFocusStrongIcon);
export const ThemedMapIcon = iconThemeColor(MapIcon);
export const ThemedRemoveIcon = iconThemeColor(RemoveIcon);
export const ThemedAddIcon = iconThemeColor(AddIcon);
